var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteCircleCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.83784,
    stroke: "black",
    strokeWidth: 0.324324
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73793 3.4586C3.65982 3.3805 3.53319 3.3805 3.45508 3.4586C3.37698 3.53671 3.37698 3.66334 3.45508 3.74145L5.71368 6.00005L3.45506 8.25866C3.37696 8.33677 3.37696 8.4634 3.45506 8.54151C3.53317 8.61961 3.6598 8.61961 3.73791 8.54151L5.99652 6.28289L8.25514 8.54151C8.33325 8.61962 8.45988 8.61962 8.53799 8.54151C8.61609 8.4634 8.61609 8.33677 8.53799 8.25866L6.27937 6.00005L8.53797 3.74145C8.61607 3.66334 8.61607 3.53671 8.53797 3.4586C8.45986 3.3805 8.33323 3.3805 8.25512 3.4586L5.99652 5.7172L3.73793 3.4586Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCircleCross);
export default __webpack_public_path__ + "static/media/delete-circle-cross.1771d3747133845791ba3f1e8346a7ba.svg";
export { ForwardRef as ReactComponent };